var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox"},[_c('div',{staticClass:"closebtn",on:{"click":function($event){return _vm.$emit('goBack')}}},[_vm._v("关闭 ×")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgbox"},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/images/taxpic.png"),"alt":"税源管理图片"}})])
}]

export { render, staticRenderFns }